// Empty State Component (per brain pattern)
import { Box, Typography, Button } from '@mui/material';
import { Inbox } from '@mui/icons-material';
import type { ReactNode } from 'react';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
};

export const EmptyState = ({
  icon = <Inbox sx={{ fontSize: 64 }} />,
  title,
  description,
  action,
}: EmptyStateProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 8,
      px: 2,
      textAlign: 'center',
    }}
  >
    <Box sx={{ color: 'text.disabled', mb: 2 }}>{icon}</Box>
    <Typography variant="h6" gutterBottom>
      {title}
    </Typography>
    {description && (
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 400 }}>
        {description}
      </Typography>
    )}
    {action && (
      <Button variant="contained" onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </Box>
);
